import React, {useEffect, useState} from 'react';
import {useNavigate, useParams} from 'react-router-dom'
import './landing.css'
import { useIdleTimer } from 'react-idle-timer'
import Swal from 'sweetalert2';
import ScaleLoader from "react-spinners/ScaleLoader";

function Landing() {
  const [loading, setLoading] = useState(false)

  useEffect(() => {
      setLoading(true)
      setTimeout( () => {
          setLoading(false)
      }, 1500)

  },[])
  let navigate = useNavigate()

  const handleOnIdle = () => {
    Swal.fire({
      icon: 'error',
      title: 'Oops...',
      text: 'You were idle for too long!',
    })
    navigate('/idle')
  }

useIdleTimer({
    timeout: 1000 * 60 * 10,
    onIdle: handleOnIdle,
  })

  const {tableid} = useParams()
  console.log(tableid)
    localStorage.setItem('tableid',tableid)
  if(tableid === undefined) {
    localStorage.setItem('tableid','Employee')
  
    
  }
 
  const table_id = localStorage.getItem('tableid', tableid)
 
  
  return (
    <div>
      { loading ?  
      <div className='spinner'>
      <ScaleLoader color={'#ffa500'} loading={loading} size={30}/>
      </div>
     : 
  
   <div className="page">
     <div className='content'>
      <h1>Welcome to Burger Tech</h1> 
      <br/>
      <h3>Table:</h3><div className='tableid'>{table_id}</div>
      <br/>
      <img className='homeImage' src="https://img2.goodfon.com/wallpaper/nbig/c/94/burger-kartofel-fri-myaso.jpg" alt="Burger Tech Image" width="500" height="333"></img>
      <br></br>
      <button className='menubutton' onClick={()=>navigate('/Browse')}>Go to Menu</button>
       </div>
  </div>
    }
    </div>
  )
}

export default Landing;
